import { render } from "./EightPeople.vue?vue&type=template&id=fc14983a&scoped=true"
import script from "./EightPeople.vue?vue&type=script&lang=js"
export * from "./EightPeople.vue?vue&type=script&lang=js"

import "./EightPeople.vue?vue&type=style&index=0&id=fc14983a&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc14983a"]])

export default __exports__